import { formatRupiah, publicBase } from "@/lib/api";
import { normalizeWa } from "@/components/WhatsAppShare";
import { DELIVERY_LABEL, calcShipping, deliveryDetail } from "@/lib/shipping";
import { decodeSel } from "@/lib/options";

export const ORDER_PARAM = "pesanan";

export const kasirOrderLink = (cart, customer, store, delivery, fee) => {
  const p = new URLSearchParams({
    [ORDER_PARAM]: cart.map((c) => `${c.id}:${c.qty}${c.code ? `:${c.code}` : ""}`).join(","),
    nama: customer.name.trim(),
    wa: customer.wa.trim(),
    kirim: delivery.method,
  });
  if (delivery.method === "antar") {
    p.set("alamat", delivery.address.trim());
    if (fee !== null) p.set("ongkir", String(fee));
  }
  return `${publicBase(store)}/kasir?${p.toString()}`;
};

export const parseOrderParams = (params) => {
  const raw = params.get(ORDER_PARAM);
  if (!raw) return null;
  const items = raw.split(",").map((s) => {
    const [id, q, code] = s.split(":");
    return { id, qty: Math.max(0, parseInt(q, 10) || 0), sel: decodeSel(code) };
  }).filter((i) => i.id && i.qty > 0);
  const antar = params.get("kirim") === "antar";
  const fee = Number(params.get("ongkir"));
  return {
    items,
    name: (params.get("nama") || "").slice(0, 60),
    wa: (params.get("wa") || "").replace(/[^0-9+\- ]/g, "").slice(0, 20),
    delivery: antar ? { method: "antar", address: (params.get("alamat") || "").slice(0, 200), fee: params.has("ongkir") && fee >= 0 ? fee : null } : null,
  };
};

export const buildOrderMessage = (store, cart, customer, delivery) => {
  const subtotal = cart.reduce((s, c) => s + c.price * c.qty, 0);
  const fee = calcShipping(store, delivery);
  const lines = [`Halo ${store.name}, saya mau pesan:`, ""];
  cart.forEach((c) => lines.push(`- ${c.name}${c.label ? ` (${c.label})` : ""} x${c.qty} = ${formatRupiah(c.price * c.qty)}`));
  lines.push("", `Subtotal: ${formatRupiah(subtotal)}`, `Pengiriman: ${DELIVERY_LABEL[delivery.method]}`);
  if (delivery.method === "antar") {
    lines.push(`Alamat: ${delivery.address.trim()}`);
    const detail = deliveryDetail(store, delivery);
    if (detail) lines.push(detail);
    lines.push(`Ongkir: ${fee === null ? "menyusul" : formatRupiah(fee)}`);
  }
  lines.push(`*Total: ${formatRupiah(subtotal + (fee || 0))}${fee === null ? " + ongkir" : ""}*`, "", `Nama: ${customer.name.trim()}`, `No. WA: ${customer.wa.trim()}`);
  if (customer.note.trim()) lines.push(`Catatan: ${customer.note.trim()}`);
  lines.push("", "(Untuk toko) Proses pesanan di kasir:", kasirOrderLink(cart, customer, store, delivery, fee));
  return lines.join("\n");
};

export const orderWaUrl = (store, cart, customer, delivery) =>
  `https://wa.me/${normalizeWa(store.whatsapp)}?text=${encodeURIComponent(buildOrderMessage(store, cart, customer, delivery))}`;
